/* CY media play (2026-10-03) — looping videos in [data-cy-play] (CY Hero video, CY Feature band): the visible video
   plays only while it is in view and pauses out of view (nothing downloads before: preload none). Reduced motion or a
   blocked autoplay = it waits, and a play button (the board's) starts it.
   2026-10-07 (owner: "minimal small button on hero image for play/pause and sound on/off - by default video run auto and
   sound is off"): [data-cy-controls] adds two small corner buttons. Play/pause is the shopper's choice and is kept when
   the film scrolls out and back; sound turns on for the desktop and the phone cut together. Labels come from the
   section settings (data-*-label). */
(() => {
  const still = matchMedia('(prefers-reduced-motion: reduce)');
  const ICON = {
    play: '<path d="M8 5.5v13l11-6.5z" fill="currentColor"/>',
    pause: '<path d="M7.5 5.5h3v13h-3zM13.5 5.5h3v13h-3z" fill="currentColor"/>',
    mute: '<path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4z" fill="currentColor"/><path d="M15.5 9.5l5 5M20.5 9.5l-5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>',
    sound: '<path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4z" fill="currentColor"/><path d="M15.5 9a4.5 4.5 0 0 1 0 6M18 6.5a8 8 0 0 1 0 11" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>'
  };
  const svg = d => '<svg viewBox="0 0 24 24" aria-hidden="true">' + d + '</svg>';
  /* 2026-10-23 (speed, MEDIA-SPEED-PLAN phase 2): a film's automatic first play waits for the page's load and an idle moment, so its
     megabytes never compete with the first paint, the fonts and the pictures (the poster shows until then). A shopper's click plays at once. */
  let idle = false; const whenIdle = [];
  const settle = () => { idle = true; whenIdle.splice(0).forEach(fn => fn()); };
  const afterLoad = () => (window.requestIdleCallback ? requestIdleCallback(settle, { timeout: 2500 }) : setTimeout(settle, 600));
  if (document.readyState === 'complete') afterLoad(); else addEventListener('load', afterLoad, { once: true });
  const init = box => {
    if (box.dataset.cyPlayOn) return; box.dataset.cyPlayOn = '1';
    const vids = [...box.querySelectorAll('video')];
    vids.forEach(v => { v.muted = true; v.playsInline = true; v.removeAttribute('autoplay'); });
    const shown = () => vids.find(v => v.offsetParent !== null || v.getClientRects().length);
    const controls = box.hasAttribute('data-cy-controls');
    let btn = null, inView = false, chosen = !still.matches, ctl = null;
    const showBtn = on => {
      if (controls) on = false;   /* the corner buttons replace the big one */
      if (on && !btn) {
        btn = document.createElement('button'); btn.type = 'button'; btn.className = 'cy-play'; btn.setAttribute('aria-label', box.dataset.playLabel || 'Play video');
        btn.innerHTML = svg(ICON.play);
        btn.addEventListener('click', () => { chosen = true; user = true; sync(); });
        box.appendChild(btn);
      }
      if (btn) btn.hidden = !on;
    };
    const paint = () => {
      if (!ctl) return;
      const playing = chosen, muted = vids[0] ? vids[0].muted : true;
      ctl.play.innerHTML = svg(playing ? ICON.pause : ICON.play);
      ctl.play.setAttribute('aria-label', playing ? (box.dataset.pauseLabel || 'Pause video') : (box.dataset.playLabel || 'Play video'));
      if (!ctl.sound) return;
      ctl.sound.innerHTML = svg(muted ? ICON.mute : ICON.sound);
      ctl.sound.setAttribute('aria-label', muted ? (box.dataset.soundOnLabel || 'Turn sound on') : (box.dataset.soundOffLabel || 'Turn sound off'));
      ctl.sound.setAttribute('aria-pressed', muted ? 'false' : 'true');
    };
    let user = false;
    const sync = () => {
      const v = shown();
      vids.forEach(x => { if (x !== v && !x.paused) x.pause(); });
      if (!v) return;
      if (v.dataset.poster && !v.hasAttribute('poster')) v.setAttribute('poster', v.dataset.poster);   /* the cut shown after a breakpoint change */
      if (!idle && !user && inView && chosen) { if (!sync.wait) { sync.wait = 1; whenIdle.push(() => { sync.wait = 0; sync(); }); } paint(); return; }
      if (inView && chosen) { const p = v.play(); if (p && p.catch) p.catch(() => { chosen = false; showBtn(true); paint(); }); showBtn(false); }
      else { if (!v.paused) v.pause(); showBtn(!chosen); }
      paint();
    };
    if (controls && vids.length) {
      const wrap = document.createElement('div'); wrap.className = 'cy-vctl';
      const mk = () => { const b = document.createElement('button'); b.type = 'button'; b.className = 'cy-vctl__btn'; wrap.appendChild(b); return b; };
      /* 2026-10-09: a film without a sound track (setting "Sound button" off -> data-no-sound) gets play / pause only */
      ctl = { play: mk(), sound: box.hasAttribute('data-no-sound') ? null : mk() };
      ctl.play.addEventListener('click', () => { chosen = !chosen; user = true; sync(); });
      if (ctl.sound) ctl.sound.addEventListener('click', () => {
        const m = !vids[0].muted; vids.forEach(x => { x.muted = m; });
        if (!m && !chosen) chosen = true;   /* sound on means the shopper wants to watch: play */
        user = true;
        sync();
      });
      box.appendChild(wrap); paint();
    }
    new IntersectionObserver(es => { inView = es[0].isIntersecting; sync(); }, { threshold: .15 }).observe(box);
    addEventListener('resize', () => { if (inView) sync(); });
  };
  const run = () => document.querySelectorAll('[data-cy-play]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
